import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Disable browser's scroll restoration
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Create root and render
const root = ReactDOM.createRoot(document.getElementById('root'));

// Function to force scroll to top
const forceScrollToTop = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

// Initial scroll to top
forceScrollToTop();

// Clean up URL if it contains index.html (before React Router initializes)
// This prevents issues where the server serves /slc/index.html but React Router expects /
if (typeof window !== 'undefined') {
  const path = window.location.pathname;
  if (path.includes('/index.html')) {
    // Replace /index.html with / in the URL without reload
    const newPath = path.replace(/\/index\.html$/, '') || '/';
    if (newPath !== path) {
      window.history.replaceState({}, '', newPath);
    }
  }
}

// Render the app
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename="/slc">
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Additional scroll prevention - wait for React Router to initialize
window.addEventListener('load', () => {
  setTimeout(forceScrollToTop, 100);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
